module.exports = __webpack_public_path__ + "img/Breadcrumb-Arrow-Black.92224f1c.svg";